import { TKIconCalendar, TKIconPencil } from "assets/images/svgs";
import Tabs from "shared/Tabs";
import Footer from "shared/Footer";
import DonorAccount from "./Account";
import DonorDonations from "./Donations";
import { useSelector } from "react-redux";
import Navbar from "layout/navbar/Navbar";
import DonorFavourites from "./Favourites";

const DonorSections = () => {
  const utc = new Date().toDateString();

  const { donor } = useSelector((state) => state.auth);

  const donorTabs = [
    {
      title: "Favourites",
      component: <DonorFavourites />,
    },
    {
      title: "My Account",
      component: <DonorAccount />,
    },
    {
      title: "Donations",
      component: <DonorDonations />,
    },
  ];

  return (
    <div>
      <Navbar />
      <div className="bg-[#EEE] pt-36 flex flex-col gap-5 justify-center items-center py-8 px-36 max-md:px-16 max-[425px]:px-8">
        <div className="w-full flex flex-wrap items-center justify-between">
          <div className="flex gap-3 my-4">
            <label className="cursor-pointer w-[100px] h-[100px] rounded-full flex justify-center items-center border-2 border-[#213784]">
              <p className="text-[48px] font-medium text-[#213874]">
                {donor?.donor?.fullName.split(" ")[0].charAt(0)}
                {donor?.donor?.fullName.split(" ")[1].charAt(0)}
              </p>
              {/* <div className="absolute bottom-8 right-0 bg-[#213874] p-1 rounded-full">
                <TKIconCamera />
              </div>
              <input className="w-0 h-0" type="file" /> */}
            </label>
            <div className="flex flex-col">
              <p className="text-[18px] font-semibold">
                {donor?.donor?.fullName}
              </p>
              <p className="text-[14px] text-[#7A7A7A]">
                {donor?.donor?.email}
              </p>
              <div className="cursor-pointer w-[80px] mt-2 flex justify-center items-center border rounded-2xl gap-x-1 border-[#213874] hover:font-medium">
                <TKIconPencil />
                <p className="text-[#213874]">Edit</p>
              </div>
            </div>
          </div>
          <div>
            <p className="uppercase text-[#878890] text-[12px]">
              Showing reports for:
            </p>
            <div className="flex items-center gap-2">
              <p className="text-[16px] font-medium">{utc}</p>
              <TKIconCalendar />
            </div>
          </div>
        </div>
        <Tabs tabs={donorTabs} />
      </div>
      <Footer />
    </div>
  );
};

export default DonorSections;
